/**
 * One line of trouble, or nothing.
 *
 * The message comes from the server's error envelope. This component never
 * writes its own text for a failure, because the server's wording is the one
 * that matches what actually happened.
 *
 * It carries a mark as well as the colour. Red text on its own is the whole
 * signal for somebody who can see it and no signal at all for somebody who
 * cannot, and this is the component every screen in the portal reports a
 * refused sign-in, a rejected window and a failed save through.
 */
export function ErrorNote({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p className="error" role="alert">
      <span className="error-mark" aria-hidden="true">
        !
      </span>
      <span>{message}</span>
    </p>
  );
}
